import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';

/**
 * Legacy route `/RapHousieRoomName` — room name entry now opens as a popup
 * on the room-type screen. Redirect preserves selected room type for the modal.
 */
const RapHousieRoomName = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { roomType, displayRoomData, isJoin, availableRooms } = location.state || {};

  useEffect(() => {
    navigate(ROUTE_ENUM.RAP_HOUSIE_ROOM_TYPE.routePath, {
      replace: true,
      state: {
        isJoin,
        availableRooms,
        openCreateRoomModal: Boolean(roomType),
        pendingRoomType: roomType || '',
        pendingDisplayRoomData: displayRoomData || null,
      },
    });
  }, [navigate, roomType, displayRoomData, isJoin, availableRooms]);

  return null;
};

export default RapHousieRoomName;
